import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useQuestionnaireStore } from "../store/useQuestionnaireStore";
import EditQuestionnaireModal from "../components/questionnaires/EditQuestionnaireModal";

const EditQuestionnairePage = () => {
  const { id } = useParams<{ id: string }>();
  const { getQuestionnaire } = useQuestionnaireStore() as any;
  const [questionnaire, setQuestionnaire] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;

    const fetchQuestionnaire = async () => {
      const q = await getQuestionnaire(id);
      setQuestionnaire(q);
    };

    fetchQuestionnaire();
  }, [id, getQuestionnaire]);

  if (!questionnaire) return <p>Loading...</p>;

  return (
    <div className="min-h-screen bg-[#f8f9ff] pt-20 px-4 lg:px-8 pb-10">
       <EditQuestionnaireModal
        questionnaire={questionnaire}
        onClose={() => navigate("/questionnaires")}
      />
    </div>
  );
};

export default EditQuestionnairePage;
